import React from 'react'
import cn from 'classnames'

import NumberPad from '../../components/NumberPad'
import List from '../../components/List'
import AsyncStatusIndicator from  '../../components/AsyncStatusIndicator'
import SecureDots from './SecureDots'
import EventPill from './EventPill'
import { ReactComponent as RefreshIcon } from '../../assets/icons/refresh.svg'
import Button from '../Button'
import Navbar from '../../containers/Navbar'

import styles from './Component.module.scss'

const UserLoginComponent = ({ venueName, events, eventsLoading, handleRefreshEvents, pin, pinSize,
    pinLoginStatus, pinLoginStatusText, handlePinEntry, handleSubmit, isSuites, isSuitesOrTabs,
    onOpenMenu }) => {
  const signInButton = !isSuites && (<Button className={styles.signIn} onClick={() => handleSubmit(isSuitesOrTabs)}>Sign In</Button>)

  let content = (
    <>
      <h1>Enter Your Passcode</h1>
      <SecureDots count={pinSize} subjectSize={pin.length} />
      <NumberPad onPressButton={handlePinEntry} />
      {signInButton}
    </>
  )

  let list = isSuites && (
    <div className={styles.eventListContainer}>
      <List
        items={events}
        component={EventPill}
        selectionType="single"
        className={styles.eventList}
        selectionDidChange={() => handleSubmit(isSuitesOrTabs)}
        containerType="ol"
      />
      <RefreshIcon onClick={handleRefreshEvents} className={cn(styles.refreshButton, { [styles.loading]: eventsLoading })} />
    </div>
  )

  const isLoading = ['loading', 'succeeded'].includes(pinLoginStatus)

  if (isLoading) {
    content = <AsyncStatusIndicator status={pinLoginStatus} statusText={pinLoginStatusText} />
    list = null
  }

  return (
    <div>
      <Navbar venueName={venueName} showMenu={onOpenMenu} className={styles.navbar} userLoginScreen={true}/>
      <div className={cn(styles.userLogin, { [styles.loading]: isLoading })}>
        <div className={styles.pinForm}>
          {content}
        </div>
        {list}
      </div>
    </div>
  )
}
export default UserLoginComponent
